import { memo } from 'react';

import DateTimeIcon from '@/assets/date-change-icon.svg?react';
import { merge } from '@/components';
import { Logo } from '@/components/core';
import { VariantLogoProps } from '@/components/logos';

export type DateTimeLogoProps = VariantLogoProps;

const IDateTimeLogo = ({ className, ...rest }: DateTimeLogoProps) => {
  return (
    <Logo className={merge('rounded-lg border border-gray-200 bg-purple-50 text-purple-700', className)} {...rest}>
      <DateTimeIcon />
    </Logo>
  );
};

export const DateTimeLogo = memo(IDateTimeLogo) as typeof IDateTimeLogo;
